<template>
	<div>
		<div class="row mb-2">
			<div class="col-sm-4">
				<router-link :to="{ name: 'UserAdd' }" class="btn btn-danger btn-rounded mb-3">
					<i class="mdi mdi-plus"></i> Добавить пользователя
				</router-link>
			</div>
		</div>

		<div class="row" v-if="!items.length">
			<div class="col-md-12 text-center">
				<div class="spinner-grow" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
		</div>

		<div class="row" v-else>
			<table class="table table-striped table-centered  table-responsive-md mb-0">
				<thead>
					<tr>
						<th>Login</th>
						<th>ID</th>
						<th>Role</th>
						<th>Active Sessions</th>
						<th>CheckIP</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, i) in items" :key="i">
						<td>{{ item.login }}</td>
						<td>{{ item._id }}</td>
						<td>{{ item.role }}</td>
						<td>{{ item.sessions.length }}</td>
						<td :class="[item.checkIP ? 'text-success' : 'text-danger']">{{ item.checkIP ? 'Да' : 'Нет' }}</td>
						<td>
							<router-link class="btn btn-sm btn-rounded btn-info" :to="{ name: 'UserEdit', params: { id: item._id } }">edit</router-link>
							<button class="btn btn-sm btn-rounded btn-danger ml-1" @click="deleteSessions(item._id)">logout</button>
							<button class="btn btn-sm btn-rounded btn-danger ml-1" @click="deleteItem(item._id)">delete</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex'
import log from '@/plugins/log'
import { to } from '@/plugins/utils'

export default {
	name: 'PortfolioList',
	data: () => {
		return {
			items: []
		}
	},
	computed: {
		filteredItems() {
			return this.items.filter(item => {
				return false
			})
		}
	},
	beforeMount() {
		this.getData()
	},
	mounted() {
		log.debug('/views/user/list', 'mounted')
	},
	methods: {
		async getData() {
			var [err, response] = await to( this.$http.get('/user/list') )
			if(err) {
				log.error('/views/user/list', 'methods.getData', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			log.debug('/views/user/list', 'methods.getData', '$http.request', response.data)

			this.items = response.data.items
		},
		async deleteItem(id) {
			if(!confirm('Уверены, что хотите удалить?')) return;

			var [err, response] = await to( this.$http.post(`/user/delete/${id}`) )
			if(err) {
				log.error('/views/user/list', 'methods.deleteItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/user/list', 'methods.deleteItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/user/list', 'methods.deleteItem', '$http.request', response.data)

			this.getData()
		},
		async deleteSessions(id) {
			if(!confirm('Уверены, что хотите выйти со всех устройств?')) return;

			var [err, response] = await to( this.$http.post(`/user/delete_sessions/${id}`) )
			if(err) {
				log.error('/views/user/list', 'methods.deleteSessions', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/user/list', 'methods.deleteSessions', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/user/list', 'methods.deleteSessions', '$http.request', response.data)

			this.getData()
		},
	}
};
</script>